<template>
	<section v-if="items.length" class="route-section align-center">
		<div class="row faq">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div class="columns column12">
					<div class="collapse-container">
						<div v-for="(item, index) in items" :key="index" class="faq-item">
							<collapse
								:header="item.header"
								:content="item.content"
								:expanded="activeCollapse === index"
								@click="setExpanded(index)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	header: { type: String, default: '' },
});

const activeCollapse = ref(null);
const setExpanded = (index) => {
	if (activeCollapse.value === index) {
		activeCollapse.value = null;
	} else {
		activeCollapse.value = index;
	}
};
</script>

<style lang="scss" scoped>
.route-section {
	padding: 0;
}

.row.faq {
	max-width: 1100px;
	position: relative;
	z-index: 3;
}

.collapse-container {
	background: var(--secondary-background-color);
}
</style>
